export default __webpack_public_path__ + "static/media/btn-color-it_it@3x.facbab18.png";